/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeContract} from '../api'

export const useMutationExecuteContract = createReactQueryMutationHook('executeContract', executeContract)
